import React, { useState } from 'react';

// Generic confirmation dialog. `onConfirm` may be async; the confirm button
// shows a busy state while it resolves.
export default function ConfirmModal({
  title = 'Are you sure?',
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  danger = false,
  onCancel,
  onConfirm,
}) {
  const [busy, setBusy] = useState(false);

  async function handleConfirm() {
    setBusy(true);
    try {
      await onConfirm();
    } finally {
      setBusy(false);
    }
  }

  return (
    <div
      className="modal-overlay"
      onClick={(e) => {
        if (e.target === e.currentTarget) onCancel();
      }}
    >
      <div className="modal" style={{ width: 380 }}>
        <div className="modal-header">
          <div className="modal-title">{title}</div>
          <button className="btn btn-sm" onClick={onCancel}>
            <i className="ti ti-x" aria-hidden="true"></i>
          </button>
        </div>
        {message && <div className="modal-body">{message}</div>}
        <div className="modal-footer">
          <button className="btn" onClick={onCancel} disabled={busy}>
            {cancelLabel}
          </button>
          <button
            className={`btn ${danger ? 'btn-danger' : 'btn-primary'}`}
            onClick={handleConfirm}
            disabled={busy}
          >
            <i className="ti ti-check" aria-hidden="true"></i>
            {busy ? 'Working...' : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
